/**
 * SummarySheetRow model
 *
 * Represents a single row of a sheet (e.g. an outbound or inbound delivery /
 * invoice sheet) that is matched against VenueWines.
 *
 * This was originally a TypeScript interface and has been converted to a
 * JavaScript class so it can be instantiated with sensible defaults.
 */
export default class SheetRow {
	constructor() {
		/** Internal flag used by bootstrap-vue to show/hide the row details */
		this._showDetails = false

		/** Upload date (Upload-Datum) */
		this.uploadDate = null

		/** Date of receipt (Dokument Datum) */
		this.documentDate = null

		/** Invoice number (Rechnungsnummer) */
		this.invoiceNumber = null

		/** Data source (Datenquelle der Suche) */
		this.dataSource = 'n/a'

		/** Category (Kategorie) */
		this.category = null

		// ----- Scores from Search

		/** VenueWine ID from poolinq database (VenueWine ID) */
		this.pqVenueWineId = null

		/** Original VenueWine ID from poolinq database, 
     * before any user changes, needed for reverting */
		this.originalPqVenueWineId = null

		/** VenueWine matching score (VenueWine Score) */
		this.pqVenueWineScore = 0

		/** Wine ID from poolinq database (Wine ID) */
		this.pqWineId = null

		/** Wine matching score (Wine Score) */
		this.pqWineScore = 0

		// ----- Comparison fields

		/** Wine name from poolinq database (Wine Name) */
		this.pqWineName = null

		/** Article name (Artikelname) */
		this.articleName = null

		/** Producer name from wine database (Wine Producer) */
		this.pqWineProducerName = null

		/** Producer/Manufacturer (Hersteller) */
		this.producer = null

		/** Vintage year (Jahrgang) */
		this.year = null

		/** Bottle size in liters (Flaschengröße) */
		this.bottleSize = null

		// ----- Geographic Information

		/** Grape variety (Rebsorte) */
		this.grapeVariety = null

		/** Color (Farbe) */
		this.wineType = null

		/** Region (Region) */
		this.region = null

		/** Land (Land) */
		this.land = null

		// ----- Price Information

		/** Quantity (Anzahl) */
		this.quantity = 0

		/** Purchase or Selling price per unit (EK Netto / VK Brutto) */
		this.unitPrice = 0

		/** Total purchase or selling price net (Gesamt EK Netto / Gesamt VK Brutto) */
		this.totalPrice = 0

		/** Supplier (VenueWine Lieferant) */
		this.pqSupplier = null

		/** Supplier (Lieferant) */
		this.supplier = null

		/** Supplier ID (Lieferant ID) */
		this.supplierId = null

		/** Vendor Article Number (Artikelnummer) */
		this.vendorArticleNumber = null

		/** Optional field to store the updater status */
		this.updaterStatus = null

		/** Original updater status from the sheet, before any user changes,
     * needed for restoring it when a match is reverted */
		this.originalUpdaterStatus = null

		/** Optional field to store the updater test status */
		this.updaterTest = null

		/** Optional field to indicate if it could be a glass wine */
		this.isGlassWine = null

		/** Optional field to indicate a readable status for email sending */
		this.emailRowStatus = null

		/** Optional field to store the date when email was sent */
		this.emailSendDate = null

		/** Optional field to indicate if a better wine match was found in the search */
		this.betterWineFound = false

		/** Boolean indicating whether the position generates revenue (Umsatz). False for losses / staff consumption. */
		this.revenue = true

		/** Loss reason from the POS loss report (Verlustgrund), e.g. "Eichbauer, Menübegleitung". */
		this.lossReason = null

		/** Optional field to store the original row index */
		this.rowIndex = null
	}
}


